var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import { tracked } from "@glimmer/tracking";
import ExternalFluxLoincMapping from "core/models/external-flux-loinc-mapping";
import BioExamOrder from "./bio-exam-order";
let Loinc = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("string"), _dec6 = attr("number"), _dec7 = attr("string"), _dec8 = attr("number"), _dec9 = attr("number"), _dec10 = attr("string"), _dec11 = attr("string"), _dec12 = attr("string"), _dec13 = attr("string"), _dec14 = attr("boolean"), _dec15 = attr(), _dec16 = attr("number"), _dec17 = hasMany("external-flux-loinc-mapping", {
  async: false,
  inverse: "bioExamObservation"
}), _dec18 = belongsTo("bio-exam-order", {
  async: false,
  inverse: "bioExamObservations"
}), _class = class Loinc extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "equivalentLoincUnit", _descriptor, this);
    // Content coming from JDVCircuitBio
    /**
     * This is also the primary key / id of the record.
     * Thus it can be used to get a record from the LOINC code:
     *
     * ```js
     * this.store.peekRecord("loinc", "12345-5");
     * ```
     */
    _initializerDefineProperty(this, "loinc", _descriptor2, this);
    _initializerDefineProperty(this, "label", _descriptor3, this);
    _initializerDefineProperty(this, "recommendedUnit", _descriptor4, this);
    _initializerDefineProperty(this, "specimen", _descriptor5, this);
    _initializerDefineProperty(this, "loincChapterLabel", _descriptor6, this);
    _initializerDefineProperty(this, "rank", _descriptor7, this);
    // Other content coming from Sêmeia
    _initializerDefineProperty(this, "customLabel", _descriptor8, this);
    _initializerDefineProperty(this, "minReferenceValue", _descriptor9, this);
    _initializerDefineProperty(this, "maxReferenceValue", _descriptor10, this);
    _initializerDefineProperty(this, "placeholder", _descriptor11, this);
    _initializerDefineProperty(this, "valueType", _descriptor12, this);
    _initializerDefineProperty(this, "defaultUnit", _descriptor13, this);
    _initializerDefineProperty(this, "referenceValuesMessage", _descriptor14, this);
    _initializerDefineProperty(this, "zeroable", _descriptor15, this);
    _initializerDefineProperty(this, "availableUnits", _descriptor16, this);
    _initializerDefineProperty(this, "identicalValuesEpsilonRatio", _descriptor17, this);
    _initializerDefineProperty(this, "externalFluxLoincMappings", _descriptor18, this);
    _initializerDefineProperty(this, "bioExamOrder", _descriptor19, this);
  }
  // There are two source of units:
  // -  `recommended_unit`, which comes from JDVCircuitBio,
  // -  `default_unit`, which is from us and let us override or define another unit.
  //
  // `default_unit` has the priority over `recommended_unit`.
  get unit() {
    return this.defaultUnit || this.recommendedUnit;
  }
  get displayLabel() {
    return this.customLabel || this.label;
  }
  get supportedUnits() {
    if (!this.unit) {
      return [];
    }
    const supportedUnits = [...this.availableUnits, this.equivalentLoincUnit].filter(Boolean);
    if (supportedUnits.includes(this.unit)) {
      return supportedUnits;
    }
    return [...supportedUnits, this.unit];
  }
  get hasAvailableUnits() {
    return Boolean(this.availableUnits.length || this.equivalentLoincUnit);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "equivalentLoincUnit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loinc", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "label", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "recommendedUnit", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "specimen", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "loincChapterLabel", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "customLabel", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "minReferenceValue", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "maxReferenceValue", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "placeholder", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "valueType", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "defaultUnit", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "referenceValuesMessage", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "zeroable", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "availableUnits", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "identicalValuesEpsilonRatio", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "externalFluxLoincMappings", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "bioExamOrder", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Loinc as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.